import { fuzzyMatch, FuzzyMatchCandidate } from '../../fuzzyMatch'
import { PlatformIndividual } from '../../../types/Individual'
import { getFullName } from './getFullName'
import { getPreferredName } from './getPreferredName'

const DEFAULT_FUZZY_THRESHOLD = 0.7

function buildMatchStrings (individual: PlatformIndividual): string[] {
  const strings: string[] = []
  const preferredName = getPreferredName(individual)
  if (preferredName) {
    strings.push(preferredName)
    strings.push(
      ...preferredName.split(' ').filter(word => word.length > 0)
    )
  }
  const fullName = getFullName(individual)
  if (fullName) {
    strings.push(fullName)
    strings.push(
      ...fullName.split(' ').filter(word => word.length > 0)
    )
  }
  return strings
}

/**
 * Find the best matching individual by name using fuzzy matching (same threshold as import).
 */
export function findIndividualByName (
  memberName: string,
  individuals: PlatformIndividual[],
  fuzzyThreshold: number = DEFAULT_FUZZY_THRESHOLD
): PlatformIndividual | undefined {
  const candidates: Array<FuzzyMatchCandidate<PlatformIndividual>> = individuals
    .map(individual => {
      const matchStrings = buildMatchStrings(individual)
      if (matchStrings.length === 0) {
        return null
      }
      return {
        result: individual,
        matchStrings
      }
    })
    .filter((candidate): candidate is FuzzyMatchCandidate<PlatformIndividual> => candidate !== null)

  return fuzzyMatch(memberName, candidates, fuzzyThreshold) ?? undefined
}
